import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo, useMemo } from "react";
import dynamic from "next/dynamic";
import { CardContextProvider } from "@/components/Card/CardContext";
import { usePaletteQuery } from "@/hooks";
import { SLIDER_MAX_NUM } from "@/lib/constants";
import routes from "@/lib/routes";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaletteContent = dynamic(() => import("@/components/PaletteContent"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/PaletteContent")]
  }
});
const MyListPalette = dynamic(() => import("@/components/MyListPalette"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/MyListPalette")]
  }
});
const GenrePalette = dynamic(() => import("@/components/GenrePalette"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/GenrePalette")]
  }
});
const EntitledPalette = dynamic(() => import("@/components/EntitledPalette"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/EntitledPalette")]
  }
});
const RankingPalette = dynamic(() => import("@/components/RankingPalette"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/RankingPalette")]
  }
});
const EntitledHtmlSnippetPalette = dynamic(() => import("@/components/EntitledHtmlSnippetPalette"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/EntitledHtmlSnippetPalette")]
  }
});
function Palette(_ref) {
  var _palette$values, _palette$values2, _palette$values3;
  let {
    id,
    hiddenPrice
  } = _ref;
  const _usePaletteQuery = usePaletteQuery({
      variables: {
        id: id,
        offset: 0,
        limit: SLIDER_MAX_NUM
      }
    }),
    {
      data
    } = _usePaletteQuery,
    result = _objectWithoutProperties(_usePaletteQuery, _excluded);
  const palette = data === null || data === void 0 ? void 0 : data.palette;
  const paletteObjects = data === null || data === void 0 ? void 0 : data.paletteObjects;
  const items = useMemo(() => {
    if (paletteObjects) {
      const metas = paletteObjects.data.map(data => data.meta || data.advertising);
      return {
        data: metas,
        pageInfo: paletteObjects.pageInfo
      };
    } else {
      return null;
    }
  }, [paletteObjects]);
  const header = {
    text: (palette === null || palette === void 0 ? void 0 : palette.header) || (palette === null || palette === void 0 ? void 0 : palette.name)
  };
  if ((palette === null || palette === void 0 || (_palette$values = palette.values) === null || _palette$values === void 0 ? void 0 : _palette$values.view_type) !== "grid") {
    header["link"] = {
      href: routes.palette(palette === null || palette === void 0 ? void 0 : palette.palette_id)
    };
  }
  return /*#__PURE__*/_jsxs(CardContextProvider, {
    hiddenPrice: hiddenPrice,
    children: [(palette === null || palette === void 0 ? void 0 : palette.schema) === "default" && /*#__PURE__*/_jsx(PaletteContent, _objectSpread({
      id: id,
      viewType: palette === null || palette === void 0 || (_palette$values2 = palette.values) === null || _palette$values2 === void 0 ? void 0 : _palette$values2.view_type,
      header: header,
      largeCard: palette === null || palette === void 0 || (_palette$values3 = palette.values) === null || _palette$values3 === void 0 ? void 0 : _palette$values3.large_card_for_slider,
      items: items
    }, result)), (palette === null || palette === void 0 ? void 0 : palette.schema) === "mylist" && /*#__PURE__*/_jsx(MyListPalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "genre" && /*#__PURE__*/_jsx(GenrePalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "entitled" && /*#__PURE__*/_jsx(EntitledPalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "ranking" && /*#__PURE__*/_jsx(RankingPalette, {
      palette: palette
    }), (palette === null || palette === void 0 ? void 0 : palette.schema) === "entitled_html_snippet" && /*#__PURE__*/_jsx(EntitledHtmlSnippetPalette, {
      palette: palette
    })]
  });
}
export default /*#__PURE__*/memo(Palette);